import { render, staticRenderFns } from "./seaFreightDataStatistics.vue?vue&type=template&id=68c64aac&scoped=true"
import script from "./seaFreightDataStatistics.vue?vue&type=script&lang=js"
export * from "./seaFreightDataStatistics.vue?vue&type=script&lang=js"
import style0 from "./seaFreightDataStatistics.vue?vue&type=style&index=0&id=68c64aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c64aac",
  null
  
)

export default component.exports